export enum InviteStatus {
    NotFound = 'notFound',
    Activated = 'activated',
    NotActivated = 'notActivated'
}